import { render, staticRenderFns } from "./HistoryItem.vue?vue&type=template&id=4e6b6c42&scoped=true"
import script from "./HistoryItem.vue?vue&type=script&lang=js"
export * from "./HistoryItem.vue?vue&type=script&lang=js"
import style0 from "./HistoryItem.vue?vue&type=style&index=0&id=4e6b6c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6b6c42",
  null
  
)

export default component.exports